import { GIVEBACK2019_DESKTOP_BREAKPOINT } from '@/utils/browser';
import { shareOnTwitter } from '@/utils/sharing';
import { easeOutQuad, font } from '@lemonade-hq/cdk';
import { clampedLerp } from '@lemonade-hq/ts-helpers';
import styled from 'styled-components';

const InternalPill = styled.div`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    height: 40px;
    padding: 12px 20px;
    ${font('main', { fontSize: '1.8rem', lineHeight: '13px' })}
  }

  ${font('main', { fontSize: '1.275rem', lineHeight: '13px' })};
  height: 32px;
  padding: 8px 11px;
  background-color: ${({ theme }) => theme.colors.cloud};
  border-radius: 23px;
  display: table;
  text-transform: lowercase;
  border: 1px solid ${({ theme }) => theme.colors.glass};
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-out;

  &:hover,
  &:active {
    background-color: ${({ theme }) => theme.colors.pink};
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.pink};
  }
`;

export default function Pill({ time, className, shareText, hashTag }) {
  const opacity = clampedLerp(0, 1, easeOutQuad(time));
  const style = { opacity, willChange: 'opacity' };
  return (
    <InternalPill
      className={className}
      style={style}
      onClick={() => {
        shareOnTwitter(shareText, 'https://bit.ly/2LIRCo8');
      }}
    >
      {`#${hashTag}`}
    </InternalPill>
  );
}
